// UI strings for the two-step length practice of a single-word recording drill
// (pronunciation/LengthSteps.tsx, Axel's decision of 2026-10-06): step 1 Harjoitusvauhti
// (exaggerated long vowels), step 2 Luonteva vauhti (Peterson's natural model). One actionable
// line per step, no intro text (docs/FINNISH-STYLE.md). en has exactly the same shape.
import { defineArea } from '../area';

export const lengthStepsFi = {
  /** The step switch's accessible name. */
  label: 'Pitkien vokaalien harjoitus',
  steps: { practice: 'Harjoitusvauhti', natural: 'Luonteva vauhti' },
  /** After step 1's name once a take passed it. */
  done: 'onnistui',
  practiceLine: 'Venytä pitkät vokaalit selvästi, lähes kaksi kertaa niin pitkiksi kuin lyhyet.',
  naturalLine: 'Sano nyt sana Petersonin tahtiin: hän puhuu välillä nopeasti, ja pituus vaihtelee puheessa luonnostaan painotuksen ja merkityksen mukaan.',
  /** Under the analysis of a take that passed step 1. */
  passed: 'Pitkät vokaalit pysyivät pitkinä.',
  next: 'Jatka luontevaan vauhtiin',
  /** The meter's mode line in step 1 (the setting's line says how to turn it off; this is a step). */
  modePractice: 'Mittari odottaa pitkät vokaalit tarkoituksella liioitellun pitkinä, noin 1,8-kertaisina lyhyeen verrattuna.',
};

export const lengthStepsEn: typeof lengthStepsFi = {
  label: 'Long-vowel practice',
  steps: { practice: 'Practice pace', natural: 'Natural pace' },
  done: 'passed',
  practiceLine: 'Stretch the long vowels clearly, nearly twice as long as the short ones.',
  naturalLine: 'Now say the word at Peterson’s pace: he sometimes speaks quite fast, and in speech length naturally varies with emphasis and meaning.',
  passed: 'The long vowels stayed long.',
  next: 'Go on to natural pace',
  modePractice: 'The meter deliberately expects exaggerated long vowels, about 1.8× a short one.',
};

// Messages.lengthSteps (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('lengthSteps', lengthStepsFi, lengthStepsEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof lengthStepsFi> {}
}
